import WebApiService from '../services/WebApiService';

export default class WorkspaceService extends WebApiService {

	constructor() {
		super();

		this.post = super.post.bind(this);
		this.get = super.get.bind(this);

		this.initialize = this.initialize.bind(this);
	}

	initialize(clientAccountId, successCallback, errorCallback) {
		this.get('/api/Workspaces/Initialize' + clientAccountId, successCallback, errorCallback);
	}

	// getWorkspaceAdminStatus(successCallback, errorCallback) { //Not a necessary call
	// 	this.get('/api/Workspaces/GetWorkspaceAdminStatus', successCallback, errorCallback);
	// }

	getMaps( clientAccountId ,successCallBack, errorCallback) {
		this.get('/api/Workspaces/Maps' + clientAccountId, successCallBack, errorCallback);
	}

	getEMaps( clientAccountId ,successCallBack, errorCallback) {
		this.get('/api/Workspaces/EMaps' + clientAccountId, successCallBack, errorCallback);
	}

	getPTMaps( clientAccountId ,successCallBack, errorCallback) {
		this.get('/api/Workspaces/PTMaps' + clientAccountId, successCallBack, errorCallback);
	}

	getCMaps( clientAccountId ,successCallBack, errorCallback) {
		this.get('/api/Workspaces/CMaps' + clientAccountId, successCallBack, errorCallback);
	}

	getUsersByUsersClientAccount(successCallback, errorCallback) {
		this.get('/api/Workspaces/GetUsersByUsersClientAccount', successCallback, errorCallback);
	}

	getworkspaceUserRoles(workspaceId, successCallback, errorCallback) {
		this.get('/api/Workspaces/GetworkspaceUserRoles/' + workspaceId, successCallback, errorCallback);
	}

	getWorkspaceShareData(workspaceId, successCallback, errorCallback) {
		this.get('/api/Workspaces/GetWorkspaceShareData/' + workspaceId, successCallback, errorCallback);
	}

	// createWorkspace(successCallback, errorCallback) {
	// 	this.get('/api/Workspaces/CreateWorkspace', successCallback, errorCallback);
	// }

	createWorkspace(clientAccountId, successCallBack, errorCallBack) {
		this.get('/api/Workspaces/CreateWorkspace/' + clientAccountId, successCallBack, errorCallBack);
	}

	deleteWorkspace(workspaceId, successCallback, errorCallback) {
		this.get('/api/Workspaces/DeleteWorkspace/' + workspaceId, successCallback, errorCallback);
	}

	saveWorkspace(workspace, successCallback, errorCallback) {
		this.post('/api/Workspaces/SaveWorkspace', workspace, successCallback, errorCallback);
	}

	saveWorkspaceShareData(shareData, successCallback, errorCallback) {
		this.post('/api/Workspaces/SaveWorkspaceShareData', shareData, successCallback, errorCallback);
	}

	getData(payload, successCallback, errorCallback) {
		this.post('/api/Workspaces/GetData', payload, successCallback, errorCallback);
	}

	fillGap(payload, successCallback, errorCallback) {
		this.post('/api/Workspaces/FillGaps', payload, successCallback, errorCallback);
	}
}